import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { ModalIntegrationConnector } from './ModalIntegrationConnectors/ModalIntegrationConnector'
import { DynamicsBasedSSOIntegrationConnector } from './SSOIntegrationConnectors/DynamicsBasedSSOConnector'
import { ConquestPlanningIntegrationConnector } from './SSOIntegrationConnectors/ConquestPlanningBasedSSOConnector'
import { BaseSSOIntegrationConnector } from './SSOIntegrationConnectors/BaseSSOIntegrationConnector'
import { OutlookCalendarSSOIntegrationConnector } from './SSOIntegrationConnectors/OutlookCalendarSSOIntegrationConnector'
import { RingCentralIntegration } from './CustomIntegrationConnectors/RingCentral/RingCentralIntegration'

export type IntegrationConnectionProps = {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  postConnectRedirectPath?: string
}

export const IntegrationConnection: React.FC<IntegrationConnectionProps> = ({ serviceId, startConnect, onConnected, postConnectRedirectPath }) => {
  switch (serviceId) {
    case IntegrationServiceId.PHONE:
    case IntegrationServiceId.EXCHANGE_CALENDAR:
    case IntegrationServiceId.REDTAIL:
    case IntegrationServiceId.SMARTOFFICE:
    case IntegrationServiceId.DELEGATED_EMAIL:
      return (
        <ModalIntegrationConnector
          serviceId={serviceId}
          startConnect={startConnect}
          onConnected={onConnected}
          postConnectRedirectPath={postConnectRedirectPath}
        />
      )
    case IntegrationServiceId.ZOOM:
    case IntegrationServiceId.WEBEX:
    case IntegrationServiceId.GOOGLE_CALENDAR:
    case IntegrationServiceId.GMAIL:
    case IntegrationServiceId.OUTLOOK_MAIL:
    case IntegrationServiceId.E_MONEY:
    case IntegrationServiceId.RIGHT_CAPITAL:
    case IntegrationServiceId.ORION:
    case IntegrationServiceId.HOLISTIPLAN:
    case IntegrationServiceId.WEALTHBOX:
    case IntegrationServiceId.HUBSPOT:
    case IntegrationServiceId.SALESFORCE:
    case IntegrationServiceId.PRACTIFI:
    case IntegrationServiceId.XLR8:
    case IntegrationServiceId.BLACK_DIAMOND:
    case IntegrationServiceId.BLACK_DIAMOND_WP:
    case IntegrationServiceId.ELEMENTS:
    case IntegrationServiceId.ZOHO:
    case IntegrationServiceId.ADVISOR_ENGINE:
    case IntegrationServiceId.PRECISE_FP:
    case IntegrationServiceId.WEALTH:
    case IntegrationServiceId.SCHWAB:
      return <BaseSSOIntegrationConnector serviceId={serviceId} startConnect={startConnect} onConnected={onConnected} stateStep={null} />
    case IntegrationServiceId.CONQUEST_PLANNING:
      return <ConquestPlanningIntegrationConnector startConnect={startConnect} onConnected={onConnected} />
    case IntegrationServiceId.RINGCENTRAL:
      return <RingCentralIntegration startConnect={startConnect} onConnected={onConnected} postConnectRedirectPath={postConnectRedirectPath} />
    case IntegrationServiceId.DYNAMICS:
    case IntegrationServiceId.ENGAGE:
      return (
        <DynamicsBasedSSOIntegrationConnector
          serviceId={serviceId}
          startConnect={startConnect}
          onConnected={onConnected}
          postConnectRedirectPath={postConnectRedirectPath}
        />
      )
    case IntegrationServiceId.OUTLOOK_CALENDAR:
      return (
        <OutlookCalendarSSOIntegrationConnector
          serviceId={serviceId}
          startConnect={startConnect}
          onConnected={onConnected}
          postConnectRedirectPath={postConnectRedirectPath}
        />
      )
    default:
      return null
  }
}
